import React from 'react';
import {Box, Grid, Hidden} from "@material-ui/core";
import {bool, object, string} from "yup";

import {FormWrapper, SubmitBtnMerchant} from "../../../../../../../helpers/FormHandlers";
import {MerchantInput, MerchantSelect, MerchantSwitch} from "../../../../../../../helpers/InputsHelpers";

import {
  bankAccountId$,
} from '../state';
import {pushLocation} from "../../../../../../../../router";
import {LINK_MANAGEMENT} from "../../../../../../../../constants/links";
import {
  apiV2BankCreate, apiV2BankDelete,
  apiV2BankDetails,
  apiV2BankList,
  apiV2BankUpdate
} from "../../../../../../../../api/merchant/bank";
import {COUNTRIES} from "../../../../../../../../constants/countries";
import {CURRENCY_ITEMS} from "../../../../../../../../constants";

export default () => {
  const [loading, setLoading] = React.useState(true);
  const [basicData, setBasicData] = React.useState({});

  const id = bankAccountId$.getValue();
  const isEdit = id !== 'create';

  const handleBack = () => {
    pushLocation({
      path: LINK_MANAGEMENT,
    });
  };

  React.useEffect(async () => {
    const currenciesList = await apiV2BankList({
      limit: 1000,
      offset: 0,
    }).then((response) => {
      const activeBanksList = (response.list || []).map(({fiat_code}) => fiat_code)
      return CURRENCY_ITEMS
        .filter((el) => !activeBanksList.includes(el.id));
    });

    if (!isEdit) {
      setBasicData({currenciesList});
      setLoading(false);
      return;
    }

    const formData = await apiV2BankDetails({id})
      .then((res) => ({
        currency: (res.fiat_code || '').toUpperCase(),
        iban: res.iban,
        swift: res.swift_code,
        aba: res.routing_code,
        bank: res.name,
        country: res.country,
        primary: res.primary
      }));

    if (!formData || !formData.currency) {
      handleBack();
      return;
    }

    setBasicData({currenciesList, formData});
    setLoading(false);
  }, []);

  if (loading) return <span />;
  if (!isEdit && !basicData.currenciesList.length) {
    return (
      <Box mt="3.5rem">
        All available bank accounts have been created. Please modify or remove any existing accounts as needed.
      </Box>
    );
  }

  const schema = object({
    currency: string().required(),
    iban: string().required(),
    swift: string().matches(/^[a-zA-Z0-9]*$/, 'Swift/Bic can only contain latin characters and numbers').required(),
    aba: string().required(),
    bank: string().matches(/^[a-zA-Z0-9.,\-–() \u0131ü&íăâ'óñúéçãêëöäłÉşșæôìČáèàÄ!øØšŚąİ/čāľň]+$/, 'Bank name can only contain latin characters and numbers, spaces and symbols .,\'&()-').required(),
    country: string().required(),
    primary: bool()
  });

  const onSubmit = (data) => {
    const fn = isEdit
      ? (data) => apiV2BankDelete({id}).then(() => apiV2BankCreate(data))
      : apiV2BankCreate;

    return fn({
      fiat_code: data.currency,
      iban: data.iban,
      swift_code: data.swift,
      name: data.bank,
      country: data.country,
      primary: data.primary || false,
      routing_code: data.aba,
    })
  };

  return (
    <Box mt="2rem">
      <FormWrapper
        data={basicData.formData || {}}
        schema={schema}
        onSubmit={onSubmit}
        onResult={handleBack}
        resultModalData={[isEdit ? 'Bank account has been changed' : 'Bank account has been created']}
      >{(formCtx) => {
        const primarySwitcher = (
          <MerchantSwitch
            text="Set as a primary bank account"
            name="primary"
            formCtx={formCtx}
            disableLabel
          />
        );

        return (
          <>
            <Grid container spacing={4}>
              <Grid item sm={6} xs={12}>
                <MerchantSelect
                  propValue="id"
                  propName="id"
                  items={isEdit ? CURRENCY_ITEMS : basicData.currenciesList}

                  label="Set currency"
                  name="currency"
                  formCtx={formCtx}
                  disabled={isEdit}
                />
              </Grid>
              <Grid item sm={6} xs={12}>
                <MerchantInput
                  label="Account number / IBAN"
                  name="iban"
                  formCtx={formCtx}
                />
              </Grid>
              <Grid item sm={6} xs={12}>
                <MerchantInput
                  label="SWIFT code / BIC"
                  name="swift"
                  formCtx={formCtx}
                />
              </Grid>
              <Grid item sm={6} xs={12}>
                <MerchantInput
                  label="ABA number / routing code"
                  name="aba"
                  formCtx={formCtx}
                />
              </Grid>
              <Grid item sm={6} xs={12}>
                <MerchantInput
                  label="Bank name"
                  name="bank"
                  formCtx={formCtx}
                />
              </Grid>
              <Grid item sm={6} xs={12}>
                <MerchantSelect
                  propName="0"
                  propValue="1"
                  items={COUNTRIES}

                  label="Country"
                  name="country"
                  formCtx={formCtx}
                />
              </Grid>
              <Hidden smUp>
                <Grid item sm={6} xs={12}>
                  {primarySwitcher}
                </Grid>
              </Hidden>
              <Grid item sm={6} xs={12}>
                <Box maxWidth="40rem">
                  <SubmitBtnMerchant formCtx={formCtx}>
                    {isEdit ? 'Update Account' : 'Add Account'}
                  </SubmitBtnMerchant>
                </Box>
              </Grid>
              <Hidden xsDown>
                <Grid item sm={6} xs={12}>
                  <Box mt=".65rem">
                    {primarySwitcher}
                  </Box>
                </Grid>
              </Hidden>
            </Grid>
          </>
        )
      }}</FormWrapper>
    </Box>
  )
}
